import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { buttonColourStyle, cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex box-border shrink-0 border-2 border-transparent font-button font-semibold items-center duration-300 justify-center whitespace-nowrap leading-none transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-20",
  {
    variants: {
      variant: {
        default:
          "bg-button rounded-button-radius text-button-foreground lg:hover:bg-button-hover lg:hover:text-button-hover-foreground",
        outline:
          "border-button-width border-button rounded-button-radius text-button lg:hover:text-button-foreground lg:hover:bg-button",
        link: "text-button border-b-width lg:hover:border-b-button",
      },
      size: {
        default: "h-11 min-h-11 max-h-11 level-4 px-6",
        xs: "h-8 min-h-8 max-h-8 level-5 px-3",
        sm: "h-9 min-h-9 max-h-9 level-4 px-4",
        lg: "h-11 min-h-11 max-h-11 level-3 font-semibold px-8",
        icon: "h-10 min-h-10 max-h-10 w-10",
        full: "w-full h-11 min-h-11 max-h-11 level-4 px-6",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(
  (
    {
      className = "",
      variant,
      size,
      dark = false,
      asChild = false,
      customColors,
      style,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : "button";
    const colourStyle = buttonColourStyle(customColors);

    return (
      <Comp
        className={cn(buttonVariants({ variant, size, dark }), className)}
        style={{ ...colourStyle, ...style }}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
